import { t } from "@/i18n-js/instance";
import { useListFormsInfiniteQuery } from "@circle-react/components/SettingsApp/Emails/components/Forms/hooks/useListFormsInfiniteQuery";
import type { Form as FormType } from "@circle-react/types/Form";
import type { EditorFieldProps } from "@circle-react-shared/BuilderUI/Editor/DefaultEditorFields";
import { Form } from "@circle-react-uikit/Form";

const i18nRoot = "builder_ui.form_block";

export const FormSelectField = ({ name, propMeta }: EditorFieldProps) => {
  const infiniteQuery = useListFormsInfiniteQuery({
    perPage: 1000,
    initialPage: 1,
  });

  const allForms = infiniteQuery.pages[0]?.records || [];
  const forms = allForms.filter(
    (form: FormType) => form.status === "published",
  );

  const totalCount = forms.length;
  const hasError = !!infiniteQuery.error;
  const isLoading = infiniteQuery.isLoading;
  const hasNoForms = totalCount === 0;

  const formOptions = forms.map((form: FormType) => ({
    text: form.name,
    value: form.id,
  }));

  const label = propMeta.nameI18n ? t(propMeta.nameI18n) : propMeta.name;

  let placeholder: string;
  if (isLoading) {
    placeholder = t([i18nRoot, "loading_forms"]);
  } else if (hasError) {
    placeholder = t([i18nRoot, "error_loading_forms"]);
  } else if (hasNoForms) {
    placeholder = t([i18nRoot, "no_forms_available"]);
  } else {
    placeholder = t([i18nRoot, "choose_form"]);
  }

  return (
    <Form.Item
      name={name}
      label={label}
      hideBorder
      hideDescription
      placeholder={placeholder}
      className="min-h-[400px] !p-0"
    >
      <Form.Select
        name={name}
        placeholder={placeholder}
        data={formOptions}
        isLoading={isLoading}
        inputContainerClassName="!px-2"
        disabled={hasError || (hasNoForms && !isLoading)}
        filterBy={(item: { text: string }, searchValue: string) =>
          item.text.toLowerCase().includes(searchValue.toLowerCase())
        }
      />
    </Form.Item>
  );
};
